const chrome = window.chrome;

const chromeSendMessageFn = chrome => (appId, message, callback) => {
	if (chrome && chrome.runtime && chrome.runtime.sendMessage) {
		return chrome.runtime.sendMessage(appId, message, callback);
	}
	return undefined;
};

const chromeSendMessage = chromeSendMessageFn(chrome);

export const sendMessageAvailable = !!chromeSendMessage;

const sendMessageFn = (chromeSendMessage, Promise) => (appId, command, data) => {
	return new Promise((resolve, reject) => {
		if (!chromeSendMessage) {
			reject('chrome.runtime.sendMessage not available');
			return;
		}
		const message = { command, data };
		chromeSendMessage(appId, message, response => {
			const { success, data } = response || {};
			if (!success) {
				reject(data);
			} else {
				resolve(data);
			}
		});
	});
};

export const sendMessage = sendMessageFn(chromeSendMessage, Promise);



// WEBPACK FOOTER //
// ./src/services/chromeMessaging.js